import {
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';
import { electron } from 'lib-shared-electron';

import { setDesktopAppPwaNoticeSeen } from 'app/utils/localStorageDesktopAppNoticeCache/localStorageDesktopAppNoticeCache';
import { createAppModal } from 'utils/modal';

import styles from './desktopAppPwaNoticeModal.module.scss';

export const DesktopAppPwaNoticeModal = createAppModal(
  { type: 'app:desktopAppPwaNotice' },
  ({ isOpen, hide }): JSX.Element | null => {
    if (!electron.isElectron()) {
      return null;
    }

    const handleHide = () => {
      setDesktopAppPwaNoticeSeen();
      hide();
    };

    return (
      <Modal isOpen={isOpen} onClose={handleHide} className={styles.modal}>
        <ModalHead title="New Desktop App" />

        <ModalBody>
          <Text.Paragraph>
            We are happy to announce that Dixa has a new Desktop App!
          </Text.Paragraph>
          <br />
          <Text.Paragraph>
            The new app brings the user experience and compatibility much closer
            to the web experience of Dixa.
          </Text.Paragraph>
          <br />
          <Text.Paragraph>
            Here’s a{' '}
            <Text.ExternalLink
              href="https://support.dixa.help/en/articles/1808-dixa-progressive-web-app"
              target="_blank"
              rel="noreferrer"
            >
              guide
            </Text.ExternalLink>{' '}
            on how to get and try out the new Desktop App!
          </Text.Paragraph>
        </ModalBody>

        <ModalFoot confirmOnClick={handleHide} confirmName="Confirm" />
      </Modal>
    );
  },
);
